<template>
  <div class="callToAction">
    <v-icon class="rounded-icon" color="#DA4453" font-size="4em" size="2em">{{ icon }}</v-icon>
    <div class="text">
      <div class="title">{{ title }}</div>
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CallToAction',
    props: {
      icon: {
        type: String,
        default: ''
      },
      title: {
        type: String,
        default: ''
      },
      text: {
        type: String,
        default: ''
      }
    }
  }
</script>

<style lang="scss" scoped>
  .callToAction {
    font-family: $primary-font;
    color: #707070;
    text-align: center;
    @include display-flex(center, flex-start, column);

    .rounded-icon {
      min-height: 60px;
      width: 50%;
      text-align: center;
      border-radius: 50%;
      border: 2px solid lightgrey;
    }

    .title {
      margin-top: 1em;
      font-weight: 600;
    }

    .text {
      margin-top: 0.5em;
    }
  }
</style>
